import Vue from 'vue'
import router from "vue-router";
import index from "../components/index.vue";
import special from "../components/special.vue";
import abnormal from "../components/abnormal.vue";

export default new router({ 
	routes: [ 
		{
	      path: '/',
		  component: index
    	}, {
	      path: '/special',
		  component: special
    	}, {
	      path: '/abnormal',
		  component: abnormal
    	}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js